import request from '@/utils/request';

//会员整体变化
export function getStatistics() {
  return request('/dashboard-report/queryOverallChangeReport', {
    method: 'GET',
  });
}
//订单金额趋势
export function getOrder(values) {
  return request('/dashboard-report/querySalesTrendReport', {
    method: 'GET',
    params: values,
  });
}
// 积分增长、消耗趋势
export function getPoint() {
  return request('/dashboard-report/queryPointTrendReport', {
    method: 'GET',
    // params: values,
  });
}
// 年龄分布
export function getAge() {
  return request('/dashboard-report/queryAgeDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
// 来源分布
export function getSource() {
  return request('/dashboard-report/queryChannelDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
// 活跃会员
export function getActiveUser() {
  return request('/dashboard-report/queryActiveMemberReport', {
    method: 'GET',
    // params: values,
  });
}
// 等级分布
export function getGrade() {
  return request('/dashboard-report/queryLevelDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
// 会员变化趋势
export function getCount() {
  return request('/dashboard-report/queryMemberTrendReport', {
    method: 'GET',
    // params: values,
  });
}
// 字典code对应汉字
export function getDict() {
  return request('/common/dict?dict_type=customer_source', {
    method: 'GET',
    // params: values,
  });
}

// 查询积分持有分布报表
export function getPointDistribution() {
  return request('/dashboard-report/queryPointDistributionReport', {
    method: 'GET',
    // params: values,
  });
}

// 查询性别分布报表
export function getGenderDistribution() {
  return request('/dashboard-report/queryGenderDistributionReport', {
    method: 'GET',
    // params: values,
  });
}

// 查询小程序整体访问报表
export function getMiniAppAccess() {
  return request('/dashboard-report/queryMiniProgramAccessReport', {
    method: 'GET',
    // params: values,
  });
}

// 查询消费能力分布报表
export function getConsumptionDistribution() {
  return request('/dashboard-report/queryConsumptionCapabilityReport', {
    method: 'GET',
    // params: values,
  });
}

// 查询地域分布报表
export function getRegionDistribution() {
  return request('/dashboard-report/queryRegionDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
